export { default } from './BadgesByDevice';
